export default __webpack_public_path__ + "static/media/icon-direction droite.dff5abd1.svg";